var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.799,
    height: 14.86,
    viewBox: "0 0 13.799 14.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-refresh",
    transform: "translate(1.061 6.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M29.273,0a.531.531,0,0,0-.531.531V2.469A6.886,6.886,0,0,0,17.067,7.43a.531.531,0,1,0,1.061,0A5.838,5.838,0,0,1,28.272,3.489l-2.351.784a.531.531,0,1,0,.335,1.008L29.441,4.22a.531.531,0,0,0,.363-.505V.531A.531.531,0,0,0,29.273,0Z",
    transform: "translate(-18.128 -6.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M63.4,221.867a.531.531,0,0,0-.531.531,5.838,5.838,0,0,1-10.144,3.941l2.351-.784a.531.531,0,1,0-.335-1.008l-3.184,1.061a.531.531,0,0,0-.363.505V229.3a.531.531,0,1,0,1.061,0v-1.939A6.886,6.886,0,0,0,63.935,222.4.531.531,0,0,0,63.4,221.867Z",
    transform: "translate(-51.198 -221.867)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.c2845703.svg";
export { ForwardRef as ReactComponent };